import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import {
  GetWebVisitDetailDocument,
  GetWebVisitDetailQuery,
  WebVisitorAppointmentDetailFragment,
  WebVisitorDetailFragment,
} from '~/graphql/generated/graphql';
import { webVisitorNotificationCongestionModalState } from '~/state/reception/atoms';

const getPatientName = (data?: GetWebVisitDetailQuery) => {
  if (!data?.node) return '';
  const appointment = data.node as WebVisitorAppointmentDetailFragment;
  const { familyName, givenName } = appointment.webVisitor as WebVisitorDetailFragment;

  return `${familyName}${givenName}`;
};

export const useFetchWebVisitorName = () => {
  const { appointmentId } = useAtomValue(webVisitorNotificationCongestionModalState);
  const [getWebVisitorProfile, { data: webVisitorData }] = useLazyQuery(GetWebVisitDetailDocument);
  const patientName = getPatientName(webVisitorData);

  useEffect(() => {
    if (appointmentId) {
      getWebVisitorProfile({ variables: { id: appointmentId } });
    }
  }, [getWebVisitorProfile, appointmentId]);

  return { patientName };
};
